import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import helixifyLegacyUdLightTheme from '@complispace/cs-apex-definitions/src/helixifyLegacyUdLightTheme';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: helixifyLegacyUdLightTheme
    }
  }
});
